import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { getNumberParts } from '../../service/FormatHelpers/FormatHelpers';

import './NumberText.css';

interface Props {
    num?: number;
    fractionalPartLength?: number;
}

export class NumberText extends React.PureComponent<Props> {
    render() {
        const { num, fractionalPartLength } = this.props;
        const formattedNumberParts = getNumberParts(Number(num), fractionalPartLength);
        let fractionalPart;

        if (formattedNumberParts.fractionalPart) {
            fractionalPart = (
                <span
                    className={Bem.cls({
                        block: 'number-text',
                        elem: 'fraction'
                    })}
                >
                    {formattedNumberParts.decimalPointSign}
                    {formattedNumberParts.fractionalPart}
                </span>
            );
        } else {
            fractionalPart = '';
        }

        return (
            <span className={Bem.cls('number-text')}>
                {formattedNumberParts.integerPart}
                {fractionalPart}
            </span>
        );
    }
}
